import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const ContentEN: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <h5>You have successfully activated your two-factor authentication!</h5>
      <p>To continue using this system you need to keep your two-factor authentication active.</p>

      <p>
        If you happen to lose or change your device but you want to continue using this system, please follow steps
        below:
      </p>
      <ol>
        <li>If you have lost your device, please contact your employer.</li>
        <li>
          If you want to change the device you are using to authenticate:
          <ul>
            <li>Press &quot;{t('twoFA.restartBtn')}&quot;</li>
            <li>Press &quot;{t('twoFA.removeBtn')}&quot;</li>
            <li>Start setting your two-factor authentication from the beginning.</li>
          </ul>
        </li>
      </ol>
    </>
  );
};

export default ContentEN;
